import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const getAuthHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

// Templates
export const listTemplates = (params = {}) => {
  return axios.get(`${API_URL}/esignature/templates`, {
    ...getAuthHeader(),
    params
  });
};

export const getTemplate = (templateId) => {
  return axios.get(`${API_URL}/esignature/templates/${templateId}`, getAuthHeader());
};

export const createTemplate = (data) => {
  return axios.post(`${API_URL}/esignature/templates`, data, getAuthHeader());
};

// Signature Requests
export const listSignatureRequests = (params = {}) => {
  return axios.get(`${API_URL}/esignature/requests`, {
    ...getAuthHeader(),
    params
  });
};

export const getSignatureRequest = (requestId) => {
  return axios.get(`${API_URL}/esignature/requests/${requestId}`, getAuthHeader());
};

export const createSignatureRequest = (data) => {
  return axios.post(`${API_URL}/esignature/requests`, data, getAuthHeader());
};

export const uploadDocumentForSigning = (formData) => {
  return axios.post(`${API_URL}/esignature/requests/upload`, formData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const sendDocumentForSignature = (data) => {
  // data: { document_id, document_type, signers, case_id?, email_subject?, email_message? }
  return axios.post(`${API_URL}/esignature/requests/from-document`, data, getAuthHeader());
};

export const sendSignatureRequest = (requestId) => {
  return axios.post(`${API_URL}/esignature/requests/${requestId}/send`, {}, getAuthHeader());
};

export const cancelSignatureRequest = (requestId) => {
  return axios.post(`${API_URL}/esignature/requests/${requestId}/cancel`, {}, getAuthHeader());
};

export const getSignatureEvents = (requestId) => {
  return axios.get(`${API_URL}/esignature/requests/${requestId}/events`, getAuthHeader());
};

// Public Signing (no auth required)
export const getSigningPage = (accessToken) => {
  return axios.get(`${API_URL}/esignature/sign/${accessToken}`);
};

export const applySignature = (accessToken, data) => {
  return axios.post(`${API_URL}/esignature/sign/${accessToken}/apply`, data);
};

export const declineSignature = (accessToken, data) => {
  return axios.post(`${API_URL}/esignature/sign/${accessToken}/decline`, data);
};

// Engagement Letters
export const listEngagementLetters = (params = {}) => {
  return axios.get(`${API_URL}/esignature/engagement-letters`, {
    ...getAuthHeader(),
    params
  });
};

export const getEngagementLetter = (letterId) => {
  return axios.get(`${API_URL}/esignature/engagement-letters/${letterId}`, getAuthHeader());
};

export const createEngagementLetter = (data) => {
  return axios.post(`${API_URL}/esignature/engagement-letters`, data, getAuthHeader());
};

// Combined Workflow
export const generateEngagementAndInvoice = (data) => {
  return axios.post(`${API_URL}/esignature/generate-engagement-and-invoice`, data, getAuthHeader());
};

// Preview Engagement Letter
export const previewEngagementLetter = (data) => {
  return axios.post(`${API_URL}/esignature/preview-engagement-letter`, data, getAuthHeader());
};

export const getEngagementLetterPreview = (signatureRequestId) => {
  return axios.get(`${API_URL}/esignature/preview-engagement-letter/${signatureRequestId}`, getAuthHeader());
};

export default {
  listTemplates,
  getTemplate,
  createTemplate,
  listSignatureRequests,
  getSignatureRequest,
  createSignatureRequest,
  uploadDocumentForSigning,
  sendDocumentForSignature,
  sendSignatureRequest,
  cancelSignatureRequest,
  getSignatureEvents,
  getSigningPage,
  applySignature,
  declineSignature,
  listEngagementLetters,
  getEngagementLetter,
  createEngagementLetter,
  generateEngagementAndInvoice,
  previewEngagementLetter,
  getEngagementLetterPreview
};
